const Page = require('../components/Page');
const Masonry = require('masonry-layout');

Page.create('.section-community-involvement', () => {
  const grid = new Masonry('.testimonial-list', {
    itemSelector: '.testimonial-list--testimonial',
  });
});
